import { NavLink } from "react-router-dom";
import { LayoutList, Calendar, Users, Gift, BarChart3, FileText, Inbox } from "lucide-react";
import { useUnreadMessagesCount } from "@/hooks/useContactMessages";

const AdminBottomNavigation = () => {
  const { data: unread = 0 } = useUnreadMessagesCount();

  const navigationItems = [
    { to: "/admin/messages", icon: Inbox, label: "Messages", title: "Messagerie", badge: unread },
    { to: "/admin/calendar", icon: Calendar, label: "Agenda", title: "Consulter et gérer l'agenda" },
    { to: "/admin/clients", icon: Users, label: "Clients", title: "Gérer la base clients" },
    { to: "/admin/gift-cards", icon: Gift, label: "Cadeaux", title: "Créer et gérer les bons cadeaux" },
    { to: "/admin/services", icon: LayoutList, label: "Services", title: "Gérer les services" },
    { to: "/admin/statistics", icon: BarChart3, label: "Stats", title: "Consulter les statistiques" },
    { to: "/admin/info", icon: FileText, label: "Infos", title: "Modifier les informations générales" },
  ];

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-t border-border z-30 lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Navigation administration mobile"
    >
      <div className="flex justify-around items-center px-1 py-2 overflow-x-auto">
        {navigationItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              title={item.title}
              className={({ isActive }) =>
                `relative flex flex-col items-center justify-center min-h-[44px] px-2 py-1 rounded-lg transition-colors ${
                  isActive
                    ? "text-bbz-green bg-bbz-green/10"
                    : "text-bbz-text/70 hover:text-bbz-text hover:bg-muted/50"
                }`
              }
            >
              <div className="relative">
                <Icon className="h-5 w-5 mb-1" />
                {item.badge ? (
                  <span className="absolute -top-1 -right-2 bg-destructive text-destructive-foreground text-[9px] min-w-[16px] h-[16px] px-1 rounded-full flex items-center justify-center font-semibold">
                    {item.badge > 9 ? "9+" : item.badge}
                  </span>
                ) : null}
              </div>
              <span className="text-[10px] font-medium leading-none">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default AdminBottomNavigation;
